module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "love-poems-from-the-heart"
    }
  }, [_c('h1', {
    staticClass: "unnumbered"
  }, [_vm._v("Love Poems from the Heart")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("These poems were created from the memoirs of my life. They highlight some of the significant events during my eighty-six years of life.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The many love poems were written for my wife of fifty-nine years. She passed on June 8, 2019. The love I had for her was insurmountable; the grief I felt was unbearable. I honor her with these love poems which gave me peace and solace.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("This book of poems is dedicated to my wife with love, Beverly Ann Scrudato, with the support of my daughters, Joanne Barbera, Laura Kusic and inspired by my granddaughters, Jenna girl, and Gabrielle Barbera, Juliana Kusic; my grandsons, Matthew Barbera. Dr. Nicolas Barbera.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0